export default {
    init() {
        let formPages = document.querySelectorAll('.wpforms-page');
        if(formPages) {
            Array.from(formPages).forEach(page => {
                let autoAdvance = page.querySelector('.contact-form--auto-advance');
                if(autoAdvance) {
                    let radios = autoAdvance.querySelectorAll('input[type=radio]');
                    let nextButton = page.querySelector('.wpforms-page-button');
                    if(radios && nextButton) {
                        Array.from(radios).forEach(radio => {
                            radio.addEventListener('click', e => {
                                nextButton.click();
                            })
                        })
                    }
                }
            })
        }

        let forms = document.querySelectorAll(".wpforms-container") ?? []
        forms.forEach((form) => {
            const formId = parseInt(form.id.replace( /[^\d.]/g, '' ));
            let complete = false;
            if (!isNaN(formId)) {
                const observer = new MutationObserver((mutations, observer) => {
                    const confirmation = form.querySelector(".wpforms-confirmation-container");
                    if (!complete && confirmation) {
                        // Trigger gtag event
                        gtag("event", "generate_lead", {
                            "lead_source": `wpforms-form-${formId}`
                        });

                        const ukForm = 11580;
                        const usForm = 11576;

                        if (typeof gtag !== "undefined") {
                            // US conversion
                            if (formId === usForm) {
                                gtag(
                                  'event',
                                  'conversion',
                                  {'send_to': 'AW-775544971/R0VLCL7qkLwaEIvB5_EC', 'value': 1.0, 'currency': 'USD'}
                                );
                            }

                            // UK conversion
                            if (formId === ukForm) {
                                gtag(
                                  'event',
                                  'conversion',
                                  {'send_to': 'AW-775544971/xrd5CPqokLwaEIvB5_EC', 'value': 1.0, 'currency': 'USD'}
                                );
                            }

                            // Trigger VWO event
                            window.VWO = window.VWO || [];
                            VWO.event = VWO.event || function () {
                                VWO.push(["event"].concat([].slice.call(arguments)))
                            };
                            VWO.event(`wpforms_form_${formId}`);
                            complete = true;
                        }
                    }
                })

                observer.observe(form, { attributes: false, childList: true, subtree: true })
            }
        })
    }
}
